export default {
  computed: {
    registrasTipasList() {
      return [
        { value: 'orlaivis', text: 'Orlaivis' },
        { value: 'juru_laivas', text: 'Jūrų laivas' },
        {
          value: 'laivelis',
          text: 'Vidaus vandenų transporto priemonė',
        },
        { value: 'prekes_zenklas', text: 'Prekių ženklas' },
        { value: 'dizainas', text: 'Dizainas' },
        { value: 'patentas', text: 'Patentas' },
        { value: 'vagonas', text: 'Geležinkelių riedmuo' },
        { value: 'ginklas', text: 'Ginklai' },
        { value: 'ktp', text: 'Transporto priemonė' },
        { value: 'traktorius', text: 'Traktorius ar kita mašina' },
        { value: 'imone', text: 'Įmonė' },
      ]
    },
    registrasRezultatasList() {
      return [
        { value: 2, text: 'Ataskaita suformuota' },
        { value: 1, text: 'Duomenų nėra' },
      ]
    },
  },
}
